/**
 * Returns a string in underscore format
 * @param {Array} str
 * @return {string}
 */
export function parseToUnderscore(str) {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return str
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();
}
